// Hideo - Teleprompter state (TeleprompterDialog.vue): the text shown, speed, text size, mirror and play/pause. Speed,
// size and mirror stay as they were between openings until the page is reloaded (never stored, like before). Opened
// from the script editor's "Teleprompter" button with the editor's current text (openFromEditor); Space and Esc in
// src/features/keyboard.ts (toggle, close). The scrolling loop runs in the component (it owns the scrolling box).
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useDialogsStore } from './dialogs'
import { useEditorStore } from './editor'
import { TP_SIZE, TP_SPEED } from '../features/teleprompter'
import { cleanHtml } from '../features/editor/html'

export const useTeleprompterStore = defineStore('teleprompter', () => {
  const dialogs = useDialogsStore()
  /** The script's HTML (already cleaned) */
  const html = ref('')
  const speed = ref<number>(TP_SPEED.start)
  /** Text size in px */
  const size = ref<number>(TP_SIZE.start)
  const mirror = ref(false)
  const playing = ref(false)

  /** Shows this HTML (cleaned by the caller), from the top, paused */
  function open(h: string): void {
    html.value = h
    playing.value = false
    dialogs.show('teleprompter', {})
  }
  /** The script editor's current text: what it would save (editorText: the page's HTML, or the Markdown turned into
   *  HTML), or the screenplay's spoken and acted parts (Fountain mode: no notes, boneyard, sections or synopses) */
  function openFromEditor(): void { open(cleanHtml(useEditorStore().prompterHtml())) }
  function toggle(): void { playing.value = !playing.value }
  function close(): void {
    playing.value = false
    dialogs.hide('teleprompter')
  }
  function toggleMirror(): void { mirror.value = !mirror.value }
  return { html, speed, size, mirror, playing, open, openFromEditor, toggle, close, toggleMirror }
})
